"use client"
import React, { useState, useEffect, Fragment } from 'react';
import { Grid } from '@mui/material';
import "@/app/style/header.scss";
import { switchLanguage, openTarget, adobeData } from '@/app/utils/Common';
import { getHeader } from "@/app/utils/request/requestList";
import { LANGTYPE_CT, LANGTYPE_EN, LANGUAGE, str2LangCode, useLanguage } from '@/app/utils/LanguageContext';
import { redirectPage, getAssetPrefix, getLoginInfo } from "@/app/utils/Common";
import cookie from 'react-cookies';
import "@/app/style/comm.scss";
// import { useMyContext } from '@/app/utils/MyContext';

const myContextState = {
  assetPrefix:"",
}
const Header = () => {
  // const { state: myContextState } = useMyContext();
  const { state: lang } = useLanguage();
  const { t: dict } = lang;
  const [headerData, setHeader] = useState<any>();
  const [salut, setSalut] = useState<string>("");
  const [searchTxt, setSearchTxt] = useState<string>("");
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showDisplayName, setShowDisplayName] = useState("");
  const [homepage, sethomepage] = useState("");
  
  const assetPrefix = getAssetPrefix();
  useEffect(() => {
    getHeader({language: lang.langCode}).then((res: any) => {
        normalizeMainMenu(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  const normalizeMainMenu = (res: any) => {
    const data = res?.item;
    if (data !== null && data !== undefined) {
      setHeader(data);
    }
  }

  const submitSearch = (e?: any) => {
    if( e && e.keyCode != '13'){
      return;
    }
    const searchVlaue = btoa(encodeURIComponent(searchTxt.replace(/^\s+/, '').replace(/\s+$/, '')));
    let url = "";
    if (searchVlaue == "") {
      if (lang.langType === LANGTYPE_EN)
        alert("Please input a search query");
      if (lang.langType === LANGTYPE_CT)
        alert("請輸入搜尋字串");
    } else {
      if (lang.langType === LANGTYPE_EN)
        url = window.globalConfig?.LINKED_PAGES?.SEARCHPAGEENG + "?g=all&k=" + searchVlaue;
      if (lang.langType === LANGTYPE_CT)
        url = window.globalConfig?.LINKED_PAGES?.SEARCHPAGECHI + "?g=all&k=" + searchVlaue;
      window.location.href = url;
    }
  } 

  useEffect(() => {  
    getLoginStatus();

    sethomepage(lang.langType === LANGTYPE_EN ? window.globalConfig?.LINKED_PAGES?.HOMEPAGEENG : window.globalConfig?.LINKED_PAGES?.HOMEPAGECHI)
  }, [])
  
  let count = 0;
  const getLoginStatus = () => {
    const isUserProfileLoaded = localStorage.getItem("IsUserProfileLoaded");
    console.log("getLoginInfo getLoginStatus isUserProfileLoaded", isUserProfileLoaded)
    if(count <= 10 && (isUserProfileLoaded == "false" || !isUserProfileLoaded)) {
      console.log("getLoginInfo getLoginStatus count", count) 
        setTimeout(() => {
          count++; 
          console.log("getLoginInfo getLoginStatus no")
          return getLoginStatus()
        }, 1000);  
    }else if(isUserProfileLoaded || count > 10 || WCIPCookie.isLoggedIn()){
      console.log("getLoginInfo getLoginStatus end")
      refreshGlobalLoginControl();
    }  
  };

  const refreshGlobalLoginControl = () => {
    const custProIn = cookie.load("custProIn");
    const {isLogin, displayName} = getLoginInfo(custProIn, lang.langType);
    setIsLogin(isLogin);
    setShowDisplayName(displayName);
    console.log("getLoginInfo", isLogin, displayName, window.WCIPCookie?.isLoggedIn())
  };
  return (
    <div id="header">
      <Grid spacing={0} className="commBContent" container sx={{ maxWidth: "1808px", margin: "0 auto", padding: "0" }} style={{
        justifyContent: "space-between",
      }}>
        <Grid item lg={3}>
          {lang.langType === LANGTYPE_EN ? (<a id="logo" className="logo_en" href={headerData?.LeftLink?.value} target={openTarget(headerData?.LeftLinkNewWindow?.value)}>{headerData?.LeftImage?.value ? (
          <img  
          src={headerData?.LeftImage?.src} 
          alt={headerData?.LeftImage?.alt} id="imgMainLogo" />) : (
          <img 
          src={`${assetPrefix}/commonImg/logo_hkjc_e.png`}   
          alt="The Hong Kong Jockey Club" id="imgMainLogo" />)}
          </a>) : (<a id="logo" className="logo_ch" href={headerData?.LeftLink?.value} target={openTarget(headerData?.LeftLinkNewWindow?.value)}>{headerData?.LeftImage?.value ? (
          <img 
          src={headerData?.LeftImage?.src} 
          alt={headerData?.LeftImage?.alt} id="imgMainLogo" />) : (
          <img 
          src={`${assetPrefix}/commonImg/logo_hkjc_c.png`} 
          alt="香港賽馬會" id="imgMainLogo" />)}</a>)}
        </Grid>
        <Grid item lg={9}>
          <div id="header_nav" className="nav">
            <div id="topNav">
              <div>
                <input name="searchkey" id="searchkey" type="hidden" />
                {
                  Object.keys(LANGUAGE).map((key: string, indexLang: number) => {
                    const code = str2LangCode(key)
                    if (lang.langCode === code) return null;
                    return (
                      <Fragment key={indexLang}>
                        <a href={homepage}>{dict("home")}</a><a onClick={() => switchLanguage(code)} className="lang">{LANGUAGE[code].display}</a>
                      </Fragment>
                    )
                  })
                }
                <input maxLength={166} title="" placeholder={dict("search")} type="text" name="" id="searchtxt" onChange={(e) => setSearchTxt(e.target.value)} onKeyUp={(e) => submitSearch(e)} />
                <input className="iconToggle" type="image" name="" id="searchimg" 
                src={`${assetPrefix}/commonImg/icon_toggle.gif`} 
                alt={dict("search")} onClick={() => submitSearch()} />
              </div>
              <div id="globalLoginControl">
                <div className="beforelogin" style={{ display: isLogin ? "none" : ""  }}><a className="login" href="javascript:;" onClick={(e) => redirectPage(e, 'login', lang.langType)}>{dict("login")}</a> / <a href="javascript:;" onClick={(e) => redirectPage(e, 'register', lang.langType)}>{dict("register")}</a><a href="javascript:;" onClick={(e) => redirectPage(e, 'help', lang.langType)} className="faq">{dict("faq")}</a></div>
                <div className="afterlogin" style={{ display: isLogin ? '' : "none"}}><div className="hkjc_login_message">
                  <span className="hkjc_greeting_name">{dict("hi")}{showDisplayName}</span><a className="logout" href="javascript:;" onClick={(e) => redirectPage(e, 'logout', lang.langType)}>{dict("logout")}</a> / </div><a href="javascript:;" onClick={(e) => redirectPage(e, 'preference', lang.langType)}>{dict("preference")}</a><a href="javascript:;" onClick={(e) => redirectPage(e, 'help', lang.langType)} className="faq">{dict("faq")}</a></div>
              </div>
              {/* <div id="ssoDiv"></div> */}
            </div>
            <div id="ewinContainer">
              <a className="ewin" onClick={(e) => waTracker(lang, 'header_ewin_home')} href={headerData?.RightLink?.value} target={openTarget(headerData?.RightLinkNewWindow?.value)}>
                <img 
                src={headerData?.RightImage?.src ? headerData?.RightImage?.src : `${assetPrefix}/commonImg/icon_ewin.png`} 
                style={{ border: 0, width: 39, height: 40 }} alt={headerData?.RightImage?.alt} id="imgSubLogo" /></a>
              <a onClick={(e) => waTracker(lang, 'header_ewin_racing')} href={headerData?.HRRedirectionLink?.value} target={openTarget(headerData?.HRRedirectionNewWindow?.value)} id="lblHR">{headerData?.HRLabel?.value}</a>
              <a onClick={(e) => waTracker(lang, 'header_ewin_football')} href={headerData?.FBRedirectionLink?.value} target={openTarget(headerData?.FBRedirectionNewWindow?.value)} id="lblFB">{headerData?.FBLabel?.value}</a>
              <a onClick={(e) => { waTracker(lang, 'header_ewin_marksix') }} href={headerData?.M6RedirectionLink?.value} target={openTarget(headerData?.M6RedirectionNewWindow?.value)} id="lblM6">{headerData?.M6Label?.value}</a>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

function waTracker(lang: any, eventId: string) {
  console.log('tracker name: ', eventId);
  adobeData(lang.langCode, "interaction", {
    pageId: "racing/local", eventId: eventId,
  });
}

export default Header